import React from 'react';
import DivSX, { DivSXProps } from '../@emotion/DivSX';

export interface BackdropProps extends DivSXProps {
  show: boolean;
}

/** 背景幕 */
const Backdrop = (props: BackdropProps) => {
  const { show, sx, ...other } = props;

  return (
    <DivSX
      sx={{
        display: show ? 'flex' : 'none',
        height: '100%',
        position: 'absolute',
        zIndex: '4000',
        width: '100%',
        left: '0',
        top: '0',
        backgroundColor: 'rgb(0 0 0 / 30%)',
        ...sx,
      }}
      {...other}
    />
  );
};

export default Backdrop;
